










































































import Vue from 'vue';
import { AutoCompleteInput, OutlinedTextInput } from '@descomplica/vue-components';
import { searchZipCode } from '@/helpers/externalServices';
import { formatZipCode } from '@/helpers/formatters';
import {
  AutocompleteOption,
  parseToAutocompleteOption,
  parseToAutocompleteOptionArray,
} from '@/helpers/autocomplete';

export interface AddressFinancialSponsorFormEvent {
  sponsorZipCode: string;
  sponsorNeighborhood: string;
  sponsorStreet: string;
  sponsorNumber: string;
  sponsorComplement: string;
  sponsorState: string;
  sponsorCity: string;
}
export default Vue.extend({
  components: { AutoCompleteInput, OutlinedTextInput },
  props: {
    sameAddress: {
      type: Boolean,
      default: false,
    },
    currentSponsorState: {
      type: String,
      default: '',
    },
    currentSponsorZipCode: {
      type: String,
      default: '',
    },
    currentSponsorNeighborhood: {
      type: String,
      default: '',
    },
    currentSponsorStreet: {
      type: String,
      default: '',
    },
    currentSponsorNumber: {
      type: String,
      default: '',
    },
    currentSponsorComplement: {
      type: String,
      default: '',
    },
    currentSponsorCity: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mask: formatZipCode,
      sponsorAddressForm: {
        sponsorZipCode: this.$store.getters.sponsorAddress?.sponsorZipCode || '',
        sponsorNeighborhood: this.$store.getters.sponsorAddress?.sponsorNeighborhood || '',
        sponsorStreet: this.$store.getters.sponsorAddress?.sponsorStreet || '',
        sponsorNumber: this.$store.getters.sponsorAddress?.sponsorNumber || '',
        sponsorComplement: this.$store.getters.sponsorAddress?.sponsorComplement || '',
        sponsorState: this.$store.getters.sponsorAddress?.sponsorState || '',
        sponsorCity: this.$store.getters.sponsorAddress?.sponsorCity || '',
      } as AddressFinancialSponsorFormEvent,
      disabled: {
        sponsorNeighborhood: true,
        sponsorStreet: true,
      },
    };
  },
  computed: {
    getStates(): AutocompleteOption[] {
      return parseToAutocompleteOptionArray(this.$store.getters.statesOptions) || [];
    },
    selectedState(): AutocompleteOption {
      return parseToAutocompleteOption(this.sponsorAddressForm.sponsorState);
    },
  },
  watch: {
    sameAddress(newValue, oldValue) {
      if (newValue) {
        this.sponsorAddressForm.sponsorZipCode = this.$store.getters.studentAddress.zipCode;
        this.sponsorAddressForm.sponsorState = this.$store.getters.studentAddress.state;
        this.sponsorAddressForm.sponsorNumber = this.$store.getters.studentAddress.number;
      } else {
        this.sponsorAddressForm.sponsorZipCode = '';
        this.sponsorAddressForm.sponsorNeighborhood = '';
        this.sponsorAddressForm.sponsorStreet = '';
        this.sponsorAddressForm.sponsorNumber = '';
        this.sponsorAddressForm.sponsorComplement = '';
        this.sponsorAddressForm.sponsorState = '';
      }
    },
  },
  created() {
    this.$store.dispatch('PULL_STATES_OPTIONS');
  },
  methods: {
    inputHandler() {
      const event: AddressFinancialSponsorFormEvent = this.sponsorAddressForm;
      this.$emit('input', event);
    },
    async completeAddress(zipCode: string) {
      await searchZipCode(zipCode).then(result => {
        this.sponsorAddressForm.sponsorNeighborhood = result?.neighborhood || '';
        this.sponsorAddressForm.sponsorStreet = result?.street || '';
        this.sponsorAddressForm.sponsorCity = result?.city || '';

        this.disabled.sponsorNeighborhood = result ? Boolean(result?.neighborhood) : false;
        this.disabled.sponsorStreet = result ? Boolean(result?.street) : false;
      });
    },
    selectHandlerState(option: AutocompleteOption) {
      this.sponsorAddressForm.sponsorState = option.value;
      this.inputHandler();
    },
  },
});
